export const scrollToTop = (options?: { behavior?: 'smooth' | 'auto' }) => {
  document.querySelector('body')?.scrollTo({ top: 0, left: 0, behavior: options?.behavior });
  document.querySelector('html')?.scrollTo({ top: 0, left: 0, behavior: options?.behavior });
};
